import { RefDataState, SchoolsByCountry } from "app/pages/AgentPricing/modules/RefData/state";
import { Agent, School, Fee, Product, Country } from "app/shared/model";
import { isAgentStopped } from "app/pages/AgentPricing/utils/agentStatus";


function getRoot(state: any) : RefDataState {
    return state.refData;
}

export function getAgentId(state: any) : string {
    return getRoot(state).agent.id;
}

export function getAgentName(state: any) : string {
    return getRoot(state).agent.name;
}

export function getAgentGroupId(state: any) : string | undefined {
    return getRoot(state).agent.groupId;
}

export function getAgentStatus(state: any): unknown {
    return getRoot(state).agent.status;
}

export function getCountries(state: any) : Country[] {
    return getRoot(state).countries;
}

export function getSchools(state: any) : School[] {
    return getRoot(state).schools;
}

export function getProducts(state: any) : Product[] {
    return getRoot(state).products;
}

export function getFees(state: any) : Fee[] {
    return getRoot(state).fees;
}

export function getSchoolsByCountry(state: any) : SchoolsByCountry[] {
    return getRoot(state).schoolsByCountry;
}

export function getOffices(state: any) : { id: string; name: string; agentId: string }[] {
    return getRoot(state).offices ?? [];
}

export function getHasExternalAgentData(state: any): boolean {
    return getRoot(state).hasExternalAgentData ?? true;
}

export function getIsAgentCommissionBlocked(state: any): boolean {
    if (!getHasExternalAgentData(state)) {
        return true;
    }

    return isAgentStopped(getAgentStatus(state));
}